'use client';

import {styled, type Theme} from '@mui/material/styles';
import {Typography} from '../primitives';

const Row = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  marginBlockStart: theme.spacing(0.75),
  paddingInline: theme.spacing(0.5),
  minHeight: 18,
}));

function helperColor(theme: Theme, error?: boolean): string {
  return error ? theme.palette.colors.text.error.default : theme.palette.colors.text.neutral.muted;
}

export interface FieldHelperTextProps {
  id?: string;
  error?: boolean;
  message?: string;
  counter?: string;
}

export function FieldHelperText({id, error, message, counter}: FieldHelperTextProps) {
  if (!message && !counter) {
    return null;
  }
  return (
    // The describedby id lives on the always-rendered Row (not the Message span,
    // which is absent for counter-only fields) so the counter is still announced.
    <Row id={id}>
      {message && (
        <Typography
          as="span"
          size="label"
          weight="regular"
          role={error ? 'alert' : undefined}
          sx={theme => ({color: helperColor(theme, error)})}
        >
          {message}
        </Typography>
      )}
      {counter && (
        <Typography
          as="span"
          size="body-3"
          weight="regular"
          sx={theme => ({color: helperColor(theme, error), whiteSpace: 'nowrap', flexShrink: 0, marginInlineStart: 'auto'})}
        >
          {counter}
        </Typography>
      )}
    </Row>
  );
}

FieldHelperText.displayName = 'FieldHelperText';
